export default __webpack_public_path__ + "static/media/familia_3.bd392e1c.jpg";